import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import { ContentProvider } from "@/lib/content";
import Home from "@/pages/Home";
import Lounge from "@/pages/Lounge";
import Repair from "@/pages/Repair";
import Maker from "@/pages/Maker";
import BusinessIT from "@/pages/BusinessIT";
import Events from "@/pages/Events";
import GameLab from "@/pages/GameLab";
import Admin from "@/pages/Admin";
import ResetPassword from "@/pages/ResetPassword";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ContentProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/lounge" element={<Lounge />} />
            <Route path="/repair" element={<Repair />} />
            <Route path="/maker" element={<Maker />} />
            <Route path="/business-it" element={<BusinessIT />} />
            <Route path="/events" element={<Events />} />
            <Route path="/ai-studio" element={<GameLab />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Route>
        </Routes>
        </ContentProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
